import type { MarketVariants } from '@/lib/i18n'

export type Slide0TitleCopy = {
  eyebrow: string
  title: string
  subtitle: string
  hintDesktop: string
  hintMobile: string
}

export const copy: MarketVariants<Slide0TitleCopy> = {
  US: {
    eyebrow: 'Chapter 2',
    title: 'The Emotional Hijack',
    subtitle:
      'Learn how scammers manipulate your decisions, and the first step to fighting back.',
    hintDesktop: 'Tip: Arrow keys also work',
    hintMobile: 'Swipe or tap Next',
  },
  ar: {
    eyebrow: 'الفصل 2',
    title: 'الاختطاف العاطفي',
    subtitle:
      'تعرّف على الطريقة التي يتلاعب بها المحتالون بقراراتك، وعلى الخطوة الأولى للتصدي لهم.',
    hintDesktop: 'نصيحة: يمكنك أيضاً استخدام مفاتيح الأسهم',
    hintMobile: 'اسحب أو اضغط "التالي"',
  },
}
